import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {
    path: '/closingdown',
    name: 'closingdown',
    component: () => import('../views/closingdown/index.vue')
    
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../layouts/index.vue'),
    redirect: '/company-search',
    children: [
      {
        path: 'company-search',
        name: 'CompanySearch',
        component: () => import('../views/companySearch/index.vue')
      },
      {
        path: 'shop-search',
        name: 'ShopSearch',
        component: () => import('../views/shopSearch/index.vue')
      },
      {
        path: 'industry-template',
        name: 'IndustryTemplate',
        component: () => import('../views/industryTemplate/index.vue')
      },
      {
        path: 'advanced-search',
        name: 'AdvancedSearch',
        component: () => import('../views/advancedSearch/index.vue')
      },
      {
        path: 'map-search',
        name: 'MapSearch',
        component: () => import('../views/shopSearch/index.vue') //('../views/mapSearch/index.vue')
      },
      {
        path: 'batch-company-search',
        name: 'BatchCompanySearch',
        component: () => import('../views/batchCompanySearch/index.vue') //('../views/batchCompanySearch/index.vue')
      },
      {
        path: 'clue-follow',
        name: 'ClueFollow',
        component: () => import('../views/clueFollow/index.vue')
      },
      {
        path: 'clue-pool',
        name: 'CluePool',
        component: () => import('../views/cluePool/index.vue')
      },
      {
        path: 'clue-monitor',
        name: 'ClueMonitor',
        component: () => import('../views/clueMonitor/index.vue')
      },
      {
        path: 'export-clue',
        name: 'ExportClue',
        component: () => import('../views/exportClue/index.vue')
      }, 
      {
        path: 'local-clue',
        name: 'LocalClue',
        component: () => import('../views/localClue/index.vue')
      },
      {
        path: 'user-info',
        name: 'UserInfo',
        component: () => import('../views/userInfo/index.vue')
      },
      {
        path: 'sub-account',
        name: 'subAccount',
        component: () => import('../views/subAccount/index.vue')
        
      },
      
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 路由守卫
router.beforeEach((to, from, next) => {
  // if (to.name === "no_favicon") {
  //   updateFavicon(document.domain, "noShow.ico");
  // } else {
  //   updateFavicon("name", "favicon.ico");
  // }
  // console.log(to,';;;')
  // 假设我们通过某个状态或属性判断用户是否登录
  const isUserLoggedIn = sessionStorage.getItem('userToken') !== null&&sessionStorage.getItem('userToken')!='';
  // const isUserLoggedIn = localStorage.getItem('userToken') !== null&&localStorage.getItem('userToken')!='';
 
  if (to.name !== 'login' && !isUserLoggedIn) {
    // 如果目标路由不是登录页面且用户未登录，则重定向到登录页面
    next({ name: 'login' });
    // next();

  } else {
    // 否则，继续正常的路由
    next();
  }
});
const updateFavicon = (title, imgPath) => {
  const link = document.querySelector("link[rel*='icon']");
  link.rel = "icon";
  link.href = process.env.BASE_URL + imgPath + "?" + new Date().getTime();
  document.getElementsByTagName("head")[0].appendChild(link);
  document.title = title;
};


export default router
